import { Tooltip } from '@platform/ui-library';
import { FormFieldClassName, Switch } from '@app/form_components';
import { useUserSettings } from '@app/hooks';
import style from './SaveCooperativeYieldCheckbox.module.scss';

export function SaveCooperativeYieldCheckbox() {
  const saveShouldYield = useUserSettings((s) => s.saveShouldYield);
  const setSaveShouldYield = useUserSettings((s) => s.setSaveShouldYield);

  return (
    <Tooltip
      className={style.container}
      fixedWidth={280}
      invert
      tooltip="When on, the save pipeline yields back to the browser between work items so the CPU should be able to catch up. When off, the legacy fully-synchronous path runs (a bit faster but may freeze the browser)."
    >
      <Switch
        fieldConfig={{ className: FormFieldClassName.labelLeft }}
        label="Cheaper save for heavy designs (takes longer)"
        name="save-cooperative-yield"
        onChange={setSaveShouldYield}
        value={saveShouldYield}
      />
    </Tooltip>
  );
}
